export default "__VITE_ASSET__CQlx5XOs__"